import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { AcceptInviteScreen } from '@/screens/accounts/SCR-108-accept-invite'

// SCR-108 Accept invitation (accounts area).
export const Route = createFileRoute('/_public/accept-invite')({
  validateSearch: z.object({ token: z.string().max(200).optional().catch(undefined) }),
  component: function AcceptInvite() {
    return <AcceptInviteScreen search={Route.useSearch()} />
  },
})
